<template>
  <ui-modal
    :show="showExchange"
    type="tag"
    title="兑换商品"
    iconType="store_2"
    @close="hideModal"
  >
    <div class="bg-popup"></div>
    <div class="exchange">
      <div class="inner" v-if="productId">
        <div class="goods" :class="type">
          <div class="icon" :style="{'background-image': `url(${info.imgUrl})`}">
          </div>
          <div class="num">
            <div class="label-box">
              <span class="label-shadow">×{{ info.num }}</span>
              <span class="label-text">×{{ info.num }}</span>
            </div>
          </div>
        </div>
        <div class="select-box">
          <span>兑换数量</span>
          <div class="num-box">
            <i class="reduce" @click="exchangeNum('reduce')"></i
            ><span>{{ num }}</span
            ><i class="add" @click="exchangeNum('add')"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left-box">
        <div class="amount-surplus">
          <div class="label-box">
            <span class="label-shadow">消耗</span>
            <span class="label-text">消耗</span>
          </div>
          <i></i>
          <div class="label-box">
            <span class="label-shadow">{{ num * info.cost }}</span>
            <span class="label-text">{{ num * info.cost }}</span>
          </div>
        </div>
        <div v-if="isMall"  class="limit" >
          <div class="label-box">
            <span class="label-shadow">限购（{{ info.dailyReward }}/{{ info.dailyLimit }}）</span>
            <span class="label-text">限购（{{ info.dailyReward }}/{{ info.dailyLimit }}）</span>
          </div>
        </div>
        <div v-else class="limit">
          <div class="label-box">
            <span class="label-shadow">限购（{{ info.totalReward }}/{{ info.totalLimit }}）</span>
            <span class="label-text">限购（{{ info.totalReward }}/{{ info.totalLimit }}）</span>
          </div>
        </div>
      </div>
      <ui-frame-bg class="betting-btn" colorType="yellow" @click.native="submit">
        <div class="label-box">
          <span class="label-shadow">兑换</span>
          <span class="label-text">兑换</span>
        </div>
      </ui-frame-bg>
    </div>
    <Prompt ref="prompt" hook="px"></Prompt>
  </ui-modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import * as api from "@/service/index";
import Prompt from "@/components/prompt";
import UiModal from "@/components/ui-modal.vue";
import UiFrameBg from '@/components/ui-frame-bg';

export default {
  components: {
    Prompt,
    UiModal,
    UiFrameBg,
  },
  data() {
    return {
      info: {},
      showExchange: false,
      productId: "",
      num: 1,
      type:"",
      inRequest: false,
      isMall: 'mall'
    };
  },
  watch: {
    inputAmount(newAmount) {
      if (newAmount && newAmount > 0) {
        this.quizAmount = newAmount;
      } else {
        this.quizAmount = this.amountList[2];
      }
    },
  },
  computed: {
    ...mapState(["scale", "token", "quizAmount","matchAmount",'amount']),
  },
  created() {
    // console.log(' this.type', this.type)
  },
  methods: {
    ...mapMutations(["HIDE_POPUP"]),
    ...mapActions(["reqUserInfo","reqRedDotState","getGoodsList"]),
    hideModal() {
      this.showExchange = false;
      this.num = 1;
      this.info = {};
      this.inRequest = false;
      this.HIDE_POPUP()
    },
    exchange(info,type) {
      // console.log('info',info)
      // console.log('type',type)
      this.type = type
      this.isMall = type == 'mall'
      // console.log(info)
      this.showExchange = true;
      this.info = info;
      this.productId = info.goodsId;
    },

    
    exchangeNum(mode) {
      // 
      // let  amount= 9999
      let daily_diff =this.info.dailyLimit - this.info.dailyReward

      let total_diff =this.info.totalLimit - this.info.totalReward
      const limit = this.isMall ? daily_diff : total_diff;

      // if (mode === 'add' && this.amount.quizRemainNum >= (this.num + 1) * this.info.cost && this.num < limit) {
      //   this.num += 1;
      // } else if (mode === 'reduce' && this.num >= 2) {
      //   this.num -= 1;
      // }
      if(mode === 'add'){
        if(this.num < limit){
          if(this.amount.quizRemainNum >= (this.num + 1) * this.info.cost){
            this.num += 1;
          }else{
            this.$refs.prompt.setMsg('竞猜币余额不足,无法增加')
          }
        }else{
          this.$refs.prompt.setMsg('可兑换次数不足，无法增加')
        }
      }else if(mode === 'reduce'){
        if(this.num >= 2){
          this.num -= 1;
        }
      }
     
    },
    
    async submit() {
      if (!this.inRequest) {
        this.inRequest = true;

        if(!this.token) return;
        let data = {
          productId: this.productId,
          num: this.num,
          token: this.token,
        };
        let response = await api.submitExchange(this.token, data);
        if (response.status == 200) {
            const tapdbTetx = this.isMall ? "每日商城" : "常驻商城"
          if (response.data == true) {
            if(this.isMall){
              this.info.dailyReward += this.num;
            }else {
              this.info.totalReward += this.num;
            }
            if(this.info.isSend){
              if(!this.token) return;
              const res =  await api.reqGiftList({token: this.token,force : true})
              if(typeof tapdb == 'undefined') return;
                if(res.status === 200){
                  res.data?.find(item => {
                  if(item.giftId == 'xc006'){
                    // 获得道具余量
                    tapdb.trackEvent(tapdbTetx, {
                      // 获得道具数量
                      '#item_gain': + this.info.coins,
                      // 道具变化余量
                      '#prop_after': item.count,
                      // 道具id
                      '#prop_id': item.giftId,
                      // 道具原因
                      '#prop_type' : this.info.title
                    });
                  }
                })
              }
            }else{
              this.reqUserInfo(true);
            
              if(typeof tapdb == 'undefined') return;
              tapdb.trackEvent(tapdbTetx, {
                  // 竞猜币消耗总量
                '#value_change': this.info.cost * this.num,
                // 竞猜余量
                '#value_after': this.amount.quizRemainNum,
                // 货币id
                '#coin_id': "xc001",
                // 获得道具数量
                '#item_gain': this.num,
                    // 获得道具
                '#prop_id': this.productId,
                    // 获得变化原因
                '#via_type': this.info.title,
                 // 获得道具原因
                '#prop_type' : this.info.title
              });
            
            
            }
            this.getGoodsList();
            this.reqRedDotState()

            this.$refs.prompt.setMsg("兑换成功～");
            

            setTimeout(() => {
              this.hideModal();
            }, 1500);
          } else {
            this.$refs.prompt.setMsg(response.data);
          }
        } else {
          this.$refs.prompt.setMsg(response.data);
        }

       
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/store/exchange";
</style>